export default __webpack_public_path__ + "78d8aec38fff407948459e030342b3c5.jpeg";